import VueRouter from "vue-router";
import routes from "./routes";
import Auth from '../auth';

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
      const loggedUser = Auth.getLoggedUser();
      if (loggedUser == null) {
          next({name: 'login'})
      } else {
          let canUserDo = true;
          to.matched.forEach(element => {
              if (element.meta.requiresActions) {
                  if (!Auth.canUserDo(element.meta.requiresActions, loggedUser)) {
                    canUserDo = false;
                  }
              }
          });
          if (canUserDo) {
            next()
          } else {
            Auth.deleteLoggedUser();
            next({name: 'login'})
          }
      }
  } else {
    if (to.matched.some(record => ['login', 'register'].indexOf(record.name) > -1)) {
      if (Auth.getLoggedUser()) {
        next({name: 'dashboard'})
      } else {
        next()
      }
    } else {
      next()
    }
  }
})

export default router;
